import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpGetProjectBudgets} from '../http/budget.http'
import {ProjectBudgets} from '../types'

export const useGetProjectBudgets = (options?: Omit<UseQueryOptions<ProjectBudgets[]>, 'queryKey' | 'queryFn'>) => {
    return useQuery({
        queryKey: [QUERY_KEYS.PROJECT_BUDGETS],
        queryFn: () => httpGetProjectBudgets(),
        ...options
    })
}
